import { jsx as _jsx } from "react/jsx-runtime";
import { WalletAPIClient } from "@ledgerhq/wallet-api-client";
import { useEffect, useMemo, useRef, useState } from "react";
import { WalletAPIProviderContext, initialContextValue } from "./context";
export * from "./types";
export function WalletAPIProvider({ children, transport, logger, getCustomModule, eventHandlers, client: providedClient, }) {
    const [state, setState] = useState(initialContextValue.state);
    const client = useRef();
    if (client.current === undefined) {
        client.current = providedClient
            ? providedClient
            : new WalletAPIClient(transport, logger, getCustomModule, eventHandlers);
    }
    useEffect(() => {
        if (eventHandlers) {
            client.current?.setEventHandlers(eventHandlers);
        }
    }, [eventHandlers]);
    const value = useMemo(() => ({
        client: client.current,
        state,
        setState,
    }), [client, state, setState]);
    return (_jsx(WalletAPIProviderContext.Provider, { value: value, children: children }));
}
//# sourceMappingURL=index.js.map